import React from 'react'
import { Modal } from './index'
import ConfirmEmailForm from '../Form/ConfirmEmailForm'
import { useAppSelector } from '../../hooks/useAppSelector'
import { RootState } from '../../states/store'

type ConfirmEmailModalProps = {
  email: string
}

const ConfirmEmailModal: React.FunctionComponent<ConfirmEmailModalProps> =
  ({}) => {
    const {
      data: { email },
    } = useAppSelector((rootState: RootState) => rootState.modals)
    return (
      <Modal maxWidth={25} showLogo>
        <ConfirmEmailForm email={email} />
      </Modal>
    )
  }

export { ConfirmEmailModal }
